import { FetchResult, gql, useMutation } from "@apollo/client";

import {
  CreateBackgroundMutationVariables,
  CreateBackgroundMutation,
} from "../generated/gql/graphql";

const CREATE_BACKGROUND = gql`
  mutation CreateBackground($input: CreateBackgroundInput!) {
    createBackground(input: $input) {
      ... on CreateBackgroundSuccess {
        background {
          id
          name
          tags
          thumbnailUrl
          url
        }
      }
      ... on CreateBackgroundError {
        message
      }
    }
  }
`;

export function useCreateBackground(): (
  variables: CreateBackgroundMutationVariables,
) => Promise<FetchResult<CreateBackgroundMutation>> {
  const [createBackground] = useMutation<
    CreateBackgroundMutation,
    CreateBackgroundMutationVariables
  >(CREATE_BACKGROUND);
  return (variables: CreateBackgroundMutationVariables) =>
    createBackground({ variables });
}
